import axios, { AxiosError } from 'axios';
import { Environment } from '../../environment';
import { Api } from './axios-config';


interface ITotais {
  nome: string;
  total: string;
}

interface IAno {
  titulo: string;
  valor: number;
}

interface IFazenda {
  titulo: string;
  valor: number;
}

interface IColhedor {
  titulo: string;
  valor: number;
}

interface IIpiranga {
  titulo: string;
  valor: number;
}

interface IPlanalto {
  titulo: string;
  valor: number;
}

interface Idiaria {
  titulo: string;
  ipiranga: number;
  planalto: number;
}

interface IMeida {
  titulo: string;
  ipiranga: number;
  planalto: number;
}

interface Itotaldia {
  valor: number;
}


export interface IDashboard {
  totais: ITotais[];
  ano: IAno[];
  fazenda: IFazenda[];
  ipiranga: IIpiranga[];
  planalto: IPlanalto[];
  diaria: Idiaria[];
  media: IMeida[];
  colhedor: IColhedor[];
  totaldia: Itotaldia[];
}

interface ErrorResponse {
  error: {
    default: string;
  };
}

const Dashboard = async (): Promise<IDashboard | Error> => {
  try {
    const urlRelativa = `/dashboard`;

    const { data } = await Api.get(urlRelativa);
    if (data) {
      return data;
    }
    return new Error('Erro ao consultar o registro.');
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response) {
        const errorMessage = axiosError.response.data.error?.default || 'Erro desconhecido';
        return new Error(errorMessage);
      } else if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      } else {
        return new Error(axiosError.message);
      }
    } else {
      return new Error('Erro inesperado');
    }
  }
};



export const DashboardService = {
  Dashboard
};